import { render, staticRenderFns } from "./tag-chapters-tree.vue?vue&type=template&id=e47cac5a&scoped=true"
import script from "./tag-chapters-tree.vue?vue&type=script&lang=js"
export * from "./tag-chapters-tree.vue?vue&type=script&lang=js"
import style0 from "./tag-chapters-tree.vue?vue&type=style&index=0&id=e47cac5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47cac5a",
  null
  
)

export default component.exports